export default [
    {
        title: 'Short overview',
        description: 'A really short video of the <b>amazing things you can do</b> under a few seconds.',
        duration: '2:17',
        tag: 'SMART',
        tagColor: 'rgb(236, 60, 122)',
        src: 'https://cdn.denticalc.com/videos/smart-tutorial-v3_720_v4',
    },
    {
        title: 'Real-life example #1',

        // description: '<b>Upper front bridge</b> + lower rear implant bridge and crown.',
        description: '<b>Crowns / bridges / implants</b>. Individual animation and prices.',
        duration: '2:18',
        tag: 'SMART',
        tagColor: 'rgb(236, 60, 122)',
        src: 'https://cdn.denticalc.com/tutorial/smart_1_720_v4',
    },
    {
        title: 'Real-life example #2',
        description: '<b>Full jaw restoration</b> on both jaws. Individual animation and prices.',
        duration: '1:48',
        tag: 'SMART',
        tagColor: 'rgb(236, 60, 122)',
        src: 'https://cdn.denticalc.com/tutorial/smart_2_720_v4',
    },
    {
        title: 'Real-life example #3',
        description: '<b>Implants + crowns</b>. Individual animation and prices.',
        duration: '1:46',
        tag: 'SMART',
        tagColor: 'rgb(236, 60, 122)',
        src: 'https://cdn.denticalc.com/tutorial/smart_3_720_v4',
    },
    {
        title: 'Real-life example #4',
        //description: 'Upper <b>implant crowns</b>, lower front crowns + rear implant bridges',
        description: '<b>Crowns / bridges / implants</b>. Individual animation and prices.',
        duration: '2:50',
        tag: 'SMART',
        tagColor: 'rgb(236, 60, 122)',
        src: 'https://cdn.denticalc.com/tutorial/smart_4_720_v4',
    },
    {
        title: 'One image is better than 1000 words',
        description: '<b>We give you 1000+ images</b>. See how you can use them to explain treatments.',
        duration: '2:15',
        tag: 'PHOTOS',
        tagColor: 'rgb(141 194 67)',
        src: 'https://cdn.denticalc.com/tutorial/photos_720',
    },
    {
        title: 'Compare treatments',
        description: 'Use compare (VS) videos to show the small but very important differences.',
        duration: '3:03',
        tag: 'VIDEOS',
        tagColor: 'rgb(243, 187, 1)',
        src: 'https://cdn.denticalc.com/tutorial/videos_720',
    },
    {
        title: 'Calculate prices',
        description: 'Give prices to your patients chairside in seconds.',
        duration: '0:57',
        tag: 'VIDEOS',
        tagColor: 'rgb(243, 187, 1)',
        src: 'https://cdn.denticalc.com/tutorial/calculator_720',
    }


    // {
    //     title: 'Short overview',
    //     description: 'A really short video of the <b>amazing things you can do</b> under a few seconds.',
    //     duration: '2:17',
    //     tag: 'SMART',
    //     tagColor: 'rgb(236, 60, 122)',
    //     src: 'https://cdn.denticalc.com/tutorial/smart_1_720_v4',
    // },
    // {
    //     title: 'Short overview',
    //     description: 'A really short video of the <b>amazing things you can do</b> under a few seconds.',
    //     duration: '2:17',
    //     tag: 'SMART',
    //     tagColor: 'rgb(236, 60, 122)',
    // },
    // {
    //     title: 'In depth tutorial',
    //     description: 'See how you can create a <b>complete treatment plan</b> with extras and discount.',
    //     duration: '3:49',
    //     tag: 'SMART',
    //     tagColor: 'rgb(236, 60, 122)',
    // },
    // {
    //     title: 'Real-life example #1',
    //     description: 'Full jaw restoration with <b>8 implants + a 12-unit-bridge</b>. Presented in seconds.',
    //     duration: '2:17',
    //     tag: 'SMART',
    //     tagColor: 'rgb(236, 60, 122)',
    // },
    // {
    //     title: 'Real-life example #2',
    //     description: '<b>Missing teeth in 15-16</b>. Treatment presented with individual animation.',
    //     duration: '2:17',
    //     tag: 'SMART',
    //     tagColor: 'rgb(236, 60, 122)',
    // },

]
